import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import api, { attachAuthToken, GenericError } from "../api"
import { LoginRequest } from "../api/login.api"

export interface LoginState {
    userInfo: Record<string, any>
    defaultWarehouse: number
    isAuthed: boolean
    isLoading: boolean
    error?: GenericError
    sideBarState: boolean
}

const accessToken = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo") || "")?.accessToken
    : null

const initialState: LoginState = {
    userInfo: localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") || "") : null,
    defaultWarehouse: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo") || "")?.ParcelHubUserWarehouse?.find(
              (phuw: Record<string, any>) => phuw?.is_default
          )?.warehouse_id
        : 1,
    isAuthed: !!accessToken || false,
    isLoading: false,
    sideBarState: false
}

export const login = createAsyncThunk("login", async (credentials: LoginRequest, thunkAPI) => {
    try {
        const response = await api.auth.login(credentials)

        return response
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const loginSlice = createSlice({
    name: "login",
    initialState,

    reducers: {
        logout: (state: LoginState) => {
            localStorage.removeItem("userInfo")
            localStorage.removeItem("accessToken")
            // reset state to initial values
            state = {
                ...initialState
            }
        },
        clearError: (state: LoginState) => {
            state.error = undefined
        },
        setSideBarState: (state: LoginState, action: PayloadAction<any>) => {
            state.sideBarState = action.payload
        }
    },

    extraReducers: {
        [login.pending.toString()]: (state, action) => {
            state.isLoading = true
        },
        [login.rejected.toString()]: (state, action) => {
            state.isLoading = false
            state.isAuthed = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [login.fulfilled.toString()]: (state, action) => {
            // set the token at the headers
            attachAuthToken(action.payload?.data?.data?.payload?.accessToken)
            const defaultWarehouse = action.payload?.data?.data?.payload?.ParcelHubUserWarehouse?.find(
                (uw: Record<string, any>) => uw?.is_default
            )?.warehouse_id
            localStorage.setItem("warehouse", defaultWarehouse)
            // state edits
            localStorage.setItem("userInfo", JSON.stringify(action.payload?.data?.data?.payload))
            if (action.payload?.data?.data?.error) {
                state.error = action.payload?.data?.data?.error || ""
            }
            state.isLoading = false
            state.isAuthed = true
            state.userInfo = action.payload?.data?.data?.payload
        }
    }
})

export const { logout, clearError, setSideBarState } = loginSlice.actions

export default loginSlice.reducer
